// extracted by mini-css-extract-plugin
export default {"activity_logs":"ActivityLogs_activity_logs__x8QY2","user_email_template":"ActivityLogs_user_email_template__KrbSu","export_calendar":"ActivityLogs_export_calendar__qZCw9"};